import { render, staticRenderFns } from "./LoaderApp.vue?vue&type=template&id=37854224&"
import script from "./LoaderApp.vue?vue&type=script&lang=js&"
export * from "./LoaderApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports